export default "__VITE_ASSET__CE7m4GzM__"